<template>
  <div v-if="order!= null">
    <div style="height: 65px;"/>
    <Progress :current-stage="currentStage"/>
    <div style="height: 65px;"/>
    <PaymentOrder v-if="!isComplete" :order="order"/>
    <SuccessOrder v-if="isComplete" :order="order"/>
    <div style="height: 65px;"/>
    <Loading/>
  </div>
</template>

<script>
import Progress from "../components/Progress";
import PaymentOrder from "./buy/PaymentOrder";
import SuccessOrder from "./buy/SuccessOrder";
import {checkError, isEmpty} from "@/util/helpers";
import {getOrderDetail} from "@/api/api";
import AlertDialog from "./dialog/AlertDialog";
import Loading from "./dialog/Loading";

export default {
  name: "OrderDetail",
  components: {Progress, PaymentOrder, SuccessOrder, Loading},
  data() {
    return {
      currentStage: 1,
      count: 1,
      state: "",
      order: null,
      isLoading: true,
      trade_no: null,
    };
  },
  computed: {
    isComplete() {
      if (isEmpty(this.order)) {
        this.currentStage = 2;
        return false;
      } else {
        if (this.completedUpdate) {
          this.currentStage = 4
        } else {
          this.currentStage = 3
        }
        return !isEmpty(this.order.pay_info);
      }
    },
    completedUpdate() {
      let val = this.order.CompletedUpdate;
      return isEmpty(val) === false;
    },
  },
  async created() {
    console.log("trade_no : " + this.$route.query.trade_no);
    this.trade_no = this.$route.query.trade_no;
    await this.getOrder();
  },
  methods: {
    async getOrder() {
      try {
        let response = await getOrderDetail(this.trade_no);
        if (await checkError(this.$dialog, response)) {
          if (isEmpty(response.data)) {
            await this.$dialog.show(AlertDialog, {text: "找不到訂單"})
          } else {
            this.order = response.data;
          }
        }
      } catch (e) {
        console.log('error', e);
      }
    }
  },
}
</script>

<style scoped>

</style>
